import React from 'react';
import { Users } from 'lucide-react';
import './About.css';

const About = () => {
  return (
    <section id="apropos" className="section section-alt">
      <div className="container">
        <h2 className="section-title">
          <Users className="title-icon" size={36} />
          {' '}À Propos / About Us / Über Uns
        </h2>
        <div className="about-content">
          <p>
            Bienvenue à la Gemeinde MPEV - une communauté vibrante de foi, d'amour et d'espoir.
            Sous la direction du Pastor Eddy, nous sommes dédiés à révéler Jésus Christ au monde,
            à partager la Parole de Dieu qui est esprit et vie, et à apporter l'abondance surnaturelle à tous.
          </p>
          <p>
            Welcome to Gemeinde MPEV - a vibrant community of faith, love, and hope.
            Under the leadership of Pastor Eddy, we are dedicated to revealing Jesus Christ to the world,
            sharing God's Word which is spirit and life, and bringing supernatural abundance to all.
          </p>
          <p>
            Willkommen bei Gemeinde MPEV - einer lebendigen Gemeinschaft des Glaubens, der Liebe und der Hoffnung.
            Unter der Leitung von Pastor Eddy widmen wir uns der Offenbarung von Jesus Christus an die Welt,
            dem Teilen von Gottes Wort, das Geist und Leben ist, und dem Bringen übernatürlicher Fülle für alle.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
